import { useEffect, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const DelegacionFilter = ({
    delegaciones = [],
    delegacionesLoading,
    selectedDelegaciones = [],
    onChangeSelectedDelegaciones,
    disableFilters
}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedDelegacionIds, setSelectedDelegacionIds] = useState([]);

    const allDelegacionesSelected = delegaciones.length > 0 && selectedDelegacionIds.length === delegaciones.length;

    useEffect(() => {
        if (dialogOpen) {
            setSelectedDelegacionIds(selectedDelegaciones?.map(delegacion => delegacion.id) || []);
        }
    }, [dialogOpen, selectedDelegaciones]);

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleCheckboxChange = (name, value) => {
        const parsedId = parseInt(name.replace('delegacion_', ''), 10);
        if (Number.isNaN(parsedId)) return;
        setSelectedDelegacionIds(prev => {
            if (value) {
                return prev.includes(parsedId) ? prev : [...prev, parsedId];
            }
            return prev.filter(id => id !== parsedId);
        });
    };

    const handleToggleAll = (value) => {
        if (value) {
            setSelectedDelegacionIds(delegaciones.map(delegacion => delegacion.id));
        } else {
            setSelectedDelegacionIds([]);
        }
    };

    const handleAccept = () => {
        const selected = delegaciones.filter(delegacion => selectedDelegacionIds.includes(delegacion.id));
        onChangeSelectedDelegaciones?.(selected);
        setDialogOpen(false);
    };

    const handleDeleteChip = (id) => {
        const nextSelection = selectedDelegaciones.filter(delegacion => delegacion.id !== id);
        onChangeSelectedDelegaciones?.(nextSelection);
    };

    return (
        <>
            <Box className='delegaciones-filter-wrapper'>
                {selectedDelegaciones?.length > 0 && (
                    <Box className='delegaciones-selected-container'>
                        <Box className='delegaciones-chip-wrapper'>
                            {selectedDelegaciones.map(delegacion => (
                                <Chip
                                    key={delegacion.id}
                                    label={delegacion.displayName}
                                    size='small'
                                    onDelete={() => handleDeleteChip(delegacion.id)}
                                    disabled={disableFilters}
                                />
                            ))}
                        </Box>
                    </Box>
                )}

                <CustomButton
                    variant='outlined'
                    onClick={handleOpenDialog}
                    disabled={delegacionesLoading || disableFilters}
                >
                    Agregar Delegaciones
                </CustomButton>
            </Box>

            <CustomDialog
                open={dialogOpen}
                dialogTitle='Seleccionar delegaciones'
                onCancel={handleCloseDialog}
                onAccept={handleAccept}
                cancelText='Cancelar'
                acceptText='Aceptar'
                fullWidth
                maxWidth='lg'
            >
                <Box className='delegaciones-dialog-list'>
                    <Box className='delegaciones-dialog-item delegaciones-dialog-item-all'>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'check',
                                displayName: 'Todos',
                                name: 'delegacion_todos',
                                labelPlacement: 'end',
                                disabled: delegacionesLoading || delegaciones.length === 0
                            }}
                            value={allDelegacionesSelected}
                            handleChange={(_, value) => handleToggleAll(value)}
                        />
                    </Box>
                    {delegaciones?.map(delegacion => (
                        <Box key={delegacion.id} className='delegaciones-dialog-item'>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'check',
                                    displayName: delegacion.displayName,
                                    name: `delegacion_${delegacion.id}`,
                                    labelPlacement: 'end',
                                    disabled: false
                                }}
                                value={selectedDelegacionIds.includes(delegacion.id)}
                                handleChange={handleCheckboxChange}
                            />
                        </Box>
                    ))}
                </Box>
            </CustomDialog>
        </>
    );
};
